import { makeStyles } from "@material-ui/core";
import img from "../../assets/images/Fondo.webp";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: 77,
    marginBottom: 60,
    [theme.breakpoints.down("sm")]: {
      marginTop: 40,
      marginBottom: 40,
      padding: "0 16px",
    },
  },
  imageContainer: {
    backgroundImage: `url(${img})`,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    width: "100%",
    minHeight: "740px",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    padding: theme.spacing(4),
    borderRadius: 12,
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },

  imgText: {
    color: "#F5FAFF",
    marginTop: 30,
    fontFamily: "Montserrat",
    fontWeight: 500,
    fontSize: "1.75rem",
    lineHeight: 1.3,
    maxWidth: "80%",
    textAlign: "center",
    [theme.breakpoints.down("md")]: {
      fontSize: "1.5rem",
    },
  },

  title: {
    margin: "0 0 24px 0",
    fontFamily: "MontserratBold",
    fontWeight: 600,
    fontSize: "1.5rem",
    lineHeight: "1.75rem",
    color: theme.palette.text.nonary,
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.25rem",
      textAlign: "center",
    },
  },

  form: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    width: "100%",
  },

  labels: {
    fontFamily: "Montserrat",
    fontWeight: 600,
    fontSize: 13,
    marginBottom: 0,
    paddingBottom: 0,

    color: theme.palette.text.tertiary,
    textAlign: "left",
  },

  textField: {
    width: "100%",
    borderRadius: 6,
    marginBottom: 6,
    fontFamily: "MontserratSemiBold",
    fontWeight: 400,
    fontSize: 16,
    color: theme.palette.text.tertiary,
    "& .MuiInputBase-input": {
      padding: "10px 12px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor:
        theme.palette.mode === "dark"
          ? theme.palette.borderSelect.main
          : "#E0E0E0",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor:
        theme.palette.mode === "dark"
          ? theme.palette.borderSelect.borderDark
          : "#010C2B",
    },

    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor:
        theme.palette.mode === "dark"
          ? theme.palette.borderSelect.borderDark
          : "#010C2B",
      borderWidth: 1,
    },
  },

  textArea: {
    width: "100%",
    borderRadius: 6,
    marginBottom: 16,
    borderColor:
      theme.palette.mode === "dark"
        ? theme.palette.borderSelect.borderDark
        : "#010C2B",
    fontFamily: "MontserratSemiBold",
    fontWeight: 400,
    fontSize: 16,
    color: theme.palette.text.tertiary,
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.borderSelect.borderDark,
      },
    },
    "& .MuiInputBase-input": {
      padding: "10px 12px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor:
        theme.palette.mode === "dark"
          ? theme.palette.borderSelect.main
          : "#E0E0E0",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor:
        theme.palette.mode === "dark"
          ? theme.palette.borderSelect.borderDark
          : "#010C2B",
    },

    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor:
        theme.palette.mode === "dark"
          ? theme.palette.borderSelect.borderDark
          : "#010C2B",
      borderWidth: 1,
    },
  },

  errorBorder: {
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.borderSelect.borderDark,
    },
    "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.borderSelect.borderDark,
    },
    "&.Mui-focused .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.borderSelect.borderDark,
    },
  },

  formDemoSelect: {
    width: "100%",
    borderRadius: 6,
    marginBottom: 6,
    fontFamily: "MontserratSemiBold",
    fontWeight: 400,
    fontSize: 16,
    color: theme.palette.text.tertiary,
    "& .MuiSelect-iconOutlined": {
      color: theme.palette.text.tertiary,
    },

    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.borderSelect.borderDark,
      },
    },
    "& .MuiInputBase-input": {
      padding: "10px 12px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor:
        theme.palette.mode === "dark"
          ? theme.palette.borderSelect.main
          : "#E0E0E0",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor:
        theme.palette.mode === "dark"
          ? theme.palette.borderSelect.borderDark
          : "#010C2B",
    },

    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor:
        theme.palette.mode === "dark"
          ? theme.palette.borderSelect.borderDark
          : "#010C2B",
      borderWidth: 1,
    },
  },

  menuDemoForm: {
    fontFamily: "Montserrat",
    fontSize: 15,
    padding: "10px 14px",

    transition: "all 0.2s ease-in-out",
    backgroundColor: "transparent",
    color: theme.palette.text.primary,

    "&:hover": {
      backgroundColor:
        theme.palette.mode === "dark"
          ? "rgba(255, 255, 255, 0.08)"
          : "rgba(0, 0, 0, 0.04)",
      color: theme.palette.text.primary,
    },

    "&.Mui-selected": {
      backgroundColor: theme.palette.mode === "dark" ? "#06E89F" : "#041370",
      color: theme.palette.mode === "dark" ? "#041370" : "#FFFFFF",

      "&:hover": {
        backgroundColor: theme.palette.mode === "dark" ? "#06E89F" : "#041370",
        opacity: 0.9,
      },
    },
  },

  buttonContainer: {
    marginTop: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing(2),
    },
  },

  privacyInfo: {
    fontSize: 12,
    textAlign: "left",
    marginTop: theme.spacing(2),
    color: theme.palette.text.secondary,
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
    },
  },
  errorText: {
    color: "#ff6b6b",
    fontSize: "0.82rem",
    marginLeft: "4px",
    letterSpacing: "0.2px",
    display: "inline-block",
    animation: "$fadeIn 0.3s ease-in-out",
    fontFamily: "MontserratRegular",
  },
  "@keyframes fadeIn": {
    from: { opacity: 0, transform: "translateY(-2px)" },
    to: { opacity: 1, transform: "translateY(0)" },
  },

  instructionText: {
    fontSize: "0.95rem",
    color: theme.palette.text.disabled,
    fontWeight: 500,
    marginBottom: "16px",
    lineHeight: 1.5,
    textAlign: "left",
    fontFamily: "MontserratRegular",
  },
  customTooltip: {
    backgroundColor: "rgba(30, 30, 30, 0.95)",
    color: "#f5f5f5",
    fontSize: "0.95rem",
    fontFamily: "MontserratRegular",
    fontWeight: 500,
    padding: "10px 14px",
    borderRadius: "10px",
    boxShadow: "0 4px 14px rgba(0, 0, 0, 0.25)",
    letterSpacing: "0.3px",
    lineHeight: 1.5,
  },

  customArrow: {
    color: "rgba(30, 30, 30, 0.95)",
  },
  errorText: {
  color: "red",
  fontSize: "0.85rem",
},

}));

export default useStyles;
